import React from 'react'
import type { UseFormReturn } from 'react-hook-form';

interface SalonContactProps {
  form: UseFormReturn<Record<string, any>>;
}

const SalonContact = ({ form }: SalonContactProps) => {
  return (
    <>
      <input hidden {...form.register('shopId')} type="text" placeholder='Please enter...' />
      <input hidden {...form.register('companyName')} type="text" placeholder='Please enter...' />
      <div className="salon-information-input-container">
        <span className="label-input">Facebook Link</span>
        <input {...form.register('facebookUrl')} type="text" placeholder='Please enter...' />
      </div>
      <div className="salon-information-input-container">
        <span className="label-input">Instagram Link</span>
        <input {...form.register('instagramUrl')} type="text" placeholder='Please enter...' />
      </div>
      <div className="salon-information-input-container">
        <span className="label-input">Google Link</span>
        <input {...form.register('googleUrl')} type="text" placeholder='Please enter...' />
      </div>
      <div className="salon-information-input-container">
        <span className="label-input">Yelp Link</span>
        <input {...form.register('yelpUrl')} type="text" placeholder='Please enter...' />
      </div>
      <div className="salon-information-input-container">
        <span className="label-input">Street</span>
        <input {...form.register('address')} type="text" placeholder='Please enter...' />
      </div>
      <div className="salon-information-input-container">
        <span className="label-input">City</span>
        <input {...form.register('city')} type="text" placeholder='Please enter...' />
      </div>
      <div className="salon-information-input-container">
        <span className="label-input">State</span>
        <input {...form.register('state')} type="text" placeholder='Please enter...' />
      </div>
      <div className="salon-information-input-container">
        <span className="label-input">Zip Code</span>
        <input {...form.register('zip')} type="text" placeholder='Please enter...' />
      </div>
    </>
  )
}

export default SalonContact;
